import { render, staticRenderFns } from "./batchReduceImport.vue?vue&type=template&id=26940aee&scoped=true"
import script from "./batchReduceImport.vue?vue&type=script&lang=js"
export * from "./batchReduceImport.vue?vue&type=script&lang=js"
import style0 from "./batchReduceImport.vue?vue&type=style&index=0&id=26940aee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26940aee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26940aee')) {
      api.createRecord('26940aee', component.options)
    } else {
      api.reload('26940aee', component.options)
    }
    module.hot.accept("./batchReduceImport.vue?vue&type=template&id=26940aee&scoped=true", function () {
      api.rerender('26940aee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/customerManage/personnelDetail/batchReduceImport.vue"
export default component.exports